import { SettingsRepository } from '../../domain/repositories/settings.repository';
import { settingsRepository } from '../repositories/settings.repository';

export const settingsRepositoryInstance: SettingsRepository = settingsRepository();
